import { makeStyles } from '@material-ui/styles';
import { Theme, Text } from '@bizzabo/design-system';
import { Event } from '@bizzabo/entities';

interface BanUserViewProps {
    event: Event;
}

const BanUserView: React.FC<BanUserViewProps> = ({ event }) => {
    const classes = useStyles();
    const orgEmail = event.supportEmail;
    const mailTo = 'mailTo:' + orgEmail;
    return (
        <div className={classes.container}>
            <div className={classes.textContainer}>
                <Text variant="t71" className={classes.banUserText}>
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    You've been blocked from all communication during this event. For more
                    information:{' '}
                    <a className={classes.mailTo} href={mailTo}>
                        {orgEmail}
                    </a>
                </Text>
            </div>
        </div>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        container: {
            height: '100%',
            backgroundColor: theme.palette.greys[100],
            borderRadius: '0 0 33px 33px',
        },
        textContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            padding: '30px 16px',
            margin: '50px 24px',

            background: theme.palette.greys['200'],
            borderRadius: 16,
        },
        banUserText: {
            textAlign: 'center',
            color: theme.palette.greys['600'],
        },
        mailTo: {
            color: 'rgb(47, 134, 215)',
        },
    }),
    {
        classNamePrefix: 'BanUserView',
    }
);

export default BanUserView;
